import { render, staticRenderFns } from "./my-earnings.vue?vue&type=template&id=5addd1a0&scoped=true&"
import script from "./my-earnings.vue?vue&type=script&lang=js&"
export * from "./my-earnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5addd1a0",
  null
  
)

export default component.exports